<div
  class="rs-flex-row rs-flex-collapse rs-flex-middle-medium rs-flex-dir-col-small-only"
  style="min-height: 0px"
>
  <div class="rs-flex-columns" [attr.data-cy]="productTypeUsageHeaderKey">
    <h2 class="rs-tit3">{{ "usage.details.title" | translate }}</h2>
  </div>
  <mprd-exceeding-amount
    [product]="product"
    [overriddenClasses]="
      'rs-txt-error rs-font-pxB rs-nowrap small-only-text-center rs-padding-left1 rs-padding-right1'
    "
    *ngIf="isExceedingAmountShown"
  ></mprd-exceeding-amount>
  <div class="rs-flex-columns">
    <p
      class="rs-txt-purple rs-font-pxB rs-txt-s3 small-only-text-center rs-padding-left1 rs-padding-right1"
    >
      {{ remainingDays }}
    </p>
  </div>
</div>
